export default __webpack_public_path__ + "static/media/setlted1.516d869a.jpg";